import styled from 'styled-components';
import { GenericContainerCard, GenericWrapper } from './MobileUtilitiesTopMatch';
import { TopDecorColor } from '../../../specific_ppv_year_info_component/single_match_card_in_info_ppv_folder/GenericComponentCssMatchCard';
import SpaceInfoMatchComponent from './GenericUtilitiesComponents/SpaceInfoMatchComponent';
import { SpaceSideWrestlerCssComponent } from './GenericUtilitiesComponents/SpaceSideWrestlerCssComponent';
import MobileRenderWrestlerWhenTwoInSide from './GenericRenderWrestlerWithLogicNumber/MobileRenderWrestlerWhenTwoInSide';
import { divideArrayWrestlersInTwo } from '../../../ui_components/GenericFunctions';

function MobileTwoInSideTopMatchRender({ matchInfo }) {

    // Divido matchInfo.wrestlers in due array uguale.. se dispari, il primo array avra' un elemento in più
    let wrestlers1, wrestlers2;

    if(matchInfo.type_match.type != 'tag') {
        wrestlers1 = matchInfo.wrestlers.slice(0, Math.ceil(matchInfo.wrestlers.length / 2));
        wrestlers2 = matchInfo.wrestlers.slice(Math.ceil(matchInfo.wrestlers.length / 2));
    } else {
        // Devo filtrare il wrestler per team dividendo in due array, quelli con team 1 e quelli team 2
        wrestlers1 = matchInfo.wrestlers.filter(wrestler => wrestler.team === 1);
        wrestlers2 = matchInfo.wrestlers.filter(wrestler => wrestler.team === 2);
    }
    
    return (
        <GenericContainerCard className='mobile-two-in-side-top-match-render'>   
            <TopDecorColor className='top-decor-color' height='10px' borderTopLeftRadius='10px' borderTopRightRadius='10px' />
            <GenericWrapper className='wrapper-triple-top-match'>

                <SpaceSideWrestlerCssComponent className='space-side-wrestler left'>
                    {wrestlers1.map((wrestler, index) => (
                        <MobileRenderWrestlerWhenTwoInSide 
                            wrestler={wrestler} 
                            side='left'
                            key={index}
                        />
                    ))}
                </SpaceSideWrestlerCssComponent>

                <SpaceInfoMatchComponent matchInfo={matchInfo} />

                <SpaceSideWrestlerCssComponent className='space-side-wrestler right'>
                    {wrestlers2.map((wrestler, index) => (
                        <MobileRenderWrestlerWhenTwoInSide 
                            wrestler={wrestler} 
                            side='right'
                            key={index}
                        />
                    ))}
                </SpaceSideWrestlerCssComponent>

            </GenericWrapper>
        </GenericContainerCard>
    )
}

export default MobileTwoInSideTopMatchRender; 